import React from 'react';
import { Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import { Check, Devices } from '@mui/icons-material';

const deviceWord = (count) => {
  const value = Math.abs(Number(count));
  const lastTwo = value % 100;
  if (lastTwo >= 11 && lastTwo <= 14) return 'устройств';
  if (value % 10 === 1) return 'устройство';
  if (value % 10 >= 2 && value % 10 <= 4) return 'устройства';
  return 'устройств';
};

const SubscribeCard = ({ subscription, current, onSelect, busy }) => (
  <Card sx={{ height: '100%', borderColor: current ? 'primary.main' : undefined, position: 'relative' }}>
    <CardContent sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5">{subscription.name}</Typography>
        {current && <Chip size="small" label="Текущий" color="primary" />}
      </Stack>
      <Typography variant="h4" color="primary.main">{Number(subscription.price_per_day).toFixed(2)} ₽</Typography>
      <Typography color="text.secondary" mb={3}>в сутки</Typography>
      <Stack spacing={1.3} mb={4}>
        <Stack direction="row" spacing={1}><Devices fontSize="small" color="primary"/><Typography>{subscription.count_devices} {deviceWord(subscription.count_devices)}</Typography></Stack>
        <Stack direction="row" spacing={1}><Check fontSize="small" color="primary"/><Typography>Все доступные локации</Typography></Stack>
        <Stack direction="row" spacing={1}><Check fontSize="small" color="primary"/><Typography>{subscription.is_premium ? 'Премиум-маршруты' : 'Стандартная скорость'}</Typography></Stack>
      </Stack>
      <Button fullWidth variant={current ? 'outlined' : 'contained'} disabled={current || busy || Number(subscription.price_per_day) === 0} onClick={() => onSelect(subscription.id)}>
        {current ? 'Подключён' : 'Выбрать тариф'}
      </Button>
    </CardContent>
  </Card>
);

export default SubscribeCard;
